__webpack_require__.p = "https://ded-ps-prod.t-static.ru/projects/invest24/prod/78564e93dcddb405950755178d6f8a01d710787c/_next/";